<template>
    <section>
        <!-- Header  -->
        <div class="flex flex-row justify-between my-4">
            <h2>Dashboard</h2>

            <div>
                <DatePicker v-model="selectedDate" inputId="dataPicker" view="month" dateFormat="mm/yy"
                    iconDisplay="input" class="w-full" :minDate="minDate" :maxDate="maxDate" @update:model-value="sendDashboardDataRequest()" />
            </div>
        </div>

        <div class="flex flex-col tablet:flex-row gap-4 justify-between items-center mb-12">
            <div class="w-[300px] text-center bg-[#f9f6eb] p-4 rounded-lg shadow-md">
                <span class="font-bold">Locações</span>
                <h3>{{ totalLocations ? totalLocations : 0 }}</h3>
            </div>
            <div class="w-[300px] text-center bg-[#f9f6eb] p-4 rounded-lg shadow-md">
                <span class="font-bold">Renda</span>
                <h3>{{ monthlyEarnings ? formatCurrency(monthlyEarnings) : 'R$ 0,00' }}</h3>
            </div>
            <div class="w-[300px] text-center bg-[#f9f6eb] p-4 rounded-lg shadow-md">
                <span class="font-bold">Ocupação</span>
                <h3>{{ occupationRate ? occupationRate + '%' : '0%' }}</h3>
            </div>
        </div>

        <!-- Charts  -->
        <section class="bg-[#f9f6eb] p-6 my-6 rounded-lg shadow-md">
            <ChartLine v-if="monthlyEarningsDays.length && monthlyEarningsValues.length" :key="chartKey" chartTitle="Renda diária" legendText="Reais" :xAxisData="monthlyEarningsDays" xAxisLegend="Data"
                :yAxisData="monthlyEarningsValues" yAxisLegend="Reais" />

            <span v-else>Carregando dados...</span>
        </section>

        <section class="bg-[#f9f6eb] p-6 my-6 rounded-lg shadow-md">
            <ChartLine v-if="bestClientNames.length && bestClientValues.length" :key="chartKey" chartTitle="Melhores clientes" legendText="Locações realizadas" :xAxisData="bestClientNames"
                xAxisLegend="Cliente" :yAxisData="bestClientValues" yAxisLegend="Locações" />

            <span v-else>Carregando dados...</span>
        </section>
    </section>
</template>

<script>
import { DatePicker } from 'primevue';
import ChartLine from '@/components/ChartLine.vue';
import DashboardService from '@/services/dashboardService.js';
import { format, parseISO } from 'date-fns';

export default {
    name: 'HomeView',
    components: {
        ChartLine,
        DatePicker
    },
    data() {
        return {
            selectedDate: new Date(),
            minDate: new Date(2025, 3),
            maxDate: new Date(),

            totalLocations: null,
            occupationRate: null,
            monthlyEarnings: null,

            // Charts data 
            monthlyEarningsDays: [],
            monthlyEarningsValues: [],

            bestClientNames: [],
            bestClientValues: [],

            chartKey: 0 // Used to force chart re-render
        }
    },
    methods: {
        async sendDashboardDataRequest() {
            try {
                const dashboardRequest = await DashboardService.getDashboardData({
                    yearMonth: format(this.selectedDate, 'yyyy/MM')
                });
                
                if (dashboardRequest.status == 200) {
                    const requestData = dashboardRequest.data.data;

                    const cardData = requestData.cardData;
                    this.monthlyEarnings = cardData.monthlyEarnings;
                    this.occupationRate = cardData.occupationRate;
                    this.totalLocations = cardData.reservationCount;

                    const chartData = requestData.chartData;
                    this.monthlyEarningsDays = chartData.monthlyEarnings.labels.map(data => format(parseISO(data), "dd/MM/yyyy"));
                    this.monthlyEarningsValues = chartData.monthlyEarnings.values.map(value => parseFloat(value.toFixed(2)));
                    this.bestClientNames = chartData.bestClients.labels;
                    this.bestClientValues = chartData.bestClients.values;

                    this.chartKey += 1; // Force chart re-render
                } else {
                    throw new Error(`Failed to get dashboard data, status ${dashboardRequest.status}`);
                }
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
                this.sendToast("Falha de processamento", "Ocorreu uma falha de processamento interna. Tente atualizar a página ou contate o suporte.", "error");
            }
        }
    },
    created() {
        this.sendDashboardDataRequest();
    }
}
</script>

<style scoped></style>